// extracted by mini-css-extract-plugin
export default {"component":"B8HTL39O"};